module.exports = __webpack_public_path__ + "img/event_placeholder.2e6b61e.webp";